import { httpRequest } from "../build-request";
export const getWithdrawals = async ({ pagination }) => {
  const route = `transactions/ambassador`;
  const { success, data } = await httpRequest({ route, headers: pagination });
  return { success, data };
};

export const sendRequestWithdrawal = async ({ requestData }) => {
  const route = `transactions/ambassador/pay-out`;
  const { success, data, kindMessage } = await httpRequest({
    route,
    method: "POST",
    body: requestData,
  });
  return { success, data, kindMessage };
};

export const getTransactionMethods = async () => {
  const route = `transactions/ambassador/methods`;
  const { success, data } = await httpRequest({ route });
  return { success, data };
}